export const DEFAULT_TIMEZONE = "America/Los_Angeles";

export const SOLVE_UNPAID_BREAKS_FF_MATCH_ALL_VERSIONS = "*";
